(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloop-demo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bl-demo-play]');
    if (!button) return;
    var video = button.closest('[data-bl-demo]').querySelector('video');
    if (!video) return;
    video.muted = false;
    try { video.currentTime = 0; } catch (e) {}
    video.controls = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
    button.hidden = true;
    // à la fin de la vidéo (sans lecture en boucle), on remet le bouton lecture
    video.onended = function () {
      if (video.loop) return;
      video.controls = false;
      try { video.currentTime = 0; } catch (e) {}
      button.hidden = false;
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloop-funnel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  // écran interne -> étape affichée (le chargement et l'aperçu comptent pour une seule étape)
  var VISIBLE_STEP = [1, 2, 3, 4, 5, 6, 6, 7, 7];
  var TOTAL = 7;
  var STORE_KEY = 'bloop-funnel-v2';

  window.BloopFunnel = window.BloopFunnel || {};

  function init(root) {
    if (root.__blfReady) return;
    root.__blfReady = true;

    var cfg = JSON.parse(root.querySelector('[data-blf-config]').textContent);
    var t = cfg.t;
    var screens = root.querySelectorAll('[data-blf-step]');
    var state = {
      step: 1, name: '', gender: '', age: cfg.ageDefault, relationship: '', email: '', adventure: null,
      loves: [], lovesOther: '', color: '', occasion: '', message: '',
      photo: null, photoOriginal: null, photoReady: null, photoUrl: '', details: '', offer: Math.max(0, Math.min(cfg.defaultOffer, cfg.offers.length - 1)), addon: false, previewUrl: '', extra: [], express: false
    };
    var loadingToken = 0;

    // les pop-ups et le message sont déplacés à la fin de <body> pour couvrir toute la page
    var portal = null;
    (function makePortal() {
      var old = document.querySelector('[data-blf-portal="' + cfg.uid + '"]');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      var moving = root.querySelectorAll('[data-blf-express], [data-blf-pick], [data-blf-toast]');
      if (!moving.length) return;
      portal = document.createElement('div');
      portal.className = 'bl blf-portal' + (root.classList.contains('bl--theme-fonts') ? ' bl--theme-fonts' : '');
      portal.setAttribute('data-blf-portal', cfg.uid);
      portal.setAttribute('style', root.getAttribute('style') || '');
      [].forEach.call(moving, function (el) { portal.appendChild(el); });
      document.body.appendChild(portal);
    })();
    function q(sel) { return root.querySelector(sel) || (portal ? portal.querySelector(sel) : null); }
    function qa(sel) { var list = [].slice.call(root.querySelectorAll(sel)); if (portal) list = list.concat([].slice.call(portal.querySelectorAll(sel))); return list; }
    function displayName() { return state.name || cfg.fallback; }
    function adventure() { return state.adventure === null ? null : cfg.adventures[state.adventure]; }
    function tokens(str) { var a = adventure(); return String(str || '').replace(/\[name\]/g, displayName()).replace(/\[adventure\]/g, a ? a.title : ''); }
    function price(v) { var n = parseFloat(String(v || '0').replace(',', '.').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
    function money(n) { return cfg.currency + n.toFixed(2); }
    function cleanLines(list) { return (list || []).map(function (l) { return String(l).replace(/<br\s*\/?>/g, '').trim(); }).filter(Boolean); }
    function capitalize(v) { return v.replace(/(^|[\s-])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); }); }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function emit(name, detail) { root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); }
    function bundleIndex() { for (var i = 0; i < cfg.offers.length; i++) { if (cfg.offers[i].kind === 'bundle') return i; } return -1; }
    function currentOffer() { return cfg.offers[state.offer] || null; }
    function freeCount() { var o = currentOffer(); var bo = o && o.kind === 'bundle' ? o : cfg.offers[bundleIndex()]; return bo ? bo.freeCount : 0; }
    function publicState() {
      return {
        step: state.step, childName: state.name, gender: state.gender, age: cfg.ageShow ? state.age : null, relationship: state.relationship, email: state.email,
        adventure: adventure(), adventureIndex: state.adventure, loves: state.loves.slice(), lovesOther: state.lovesOther, color: state.color,
        occasion: state.occasion, message: state.message, photo: state.photo, photoOriginal: state.photoOriginal, details: state.details,
        offer: cfg.offers[state.offer] || null, addon: state.addon, previewUrl: state.previewUrl,
        extraMovies: state.extra.map(function (m) { return { child: m.child === 'other' ? 'another child' : 'same child', name: m.child === 'other' ? m.name : state.name, photo: m.child === 'other' ? m.photo : state.photo, adventure: cfg.adventures[m.adventure] || null }; }), express: state.express
      };
    }
    window.BloopFunnel.getState = publicState;

    // ---------- Google Sheet : enregistre chaque parent, même sans achat ----------
    var STEP_LABELS = ['1 · Infos enfant', '2 · Aventure', '3 · Goûts', '4 · Occasion', '5 · Photo', '6 · Chargement', '7 · Aperçu vu', '8 · Offres', '9 · Choix des films'];
    state.maxStep = 1;
    var leadId = '', utm = {};
    try {
      leadId = sessionStorage.getItem('bloop-lead-id') || '';
      if (!leadId) { leadId = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7); sessionStorage.setItem('bloop-lead-id', leadId); }
      utm = JSON.parse(sessionStorage.getItem('bloop-utm') || 'null') || {};
      var sp = new URLSearchParams(location.search);
      if (sp.get('utm_source') || sp.get('utm_campaign')) {
        utm = { source: sp.get('utm_source') || '', campaign: sp.get('utm_campaign') || '' };
        sessionStorage.setItem('bloop-utm', JSON.stringify(utm));
      }
    } catch (e) { if (!leadId) leadId = 'L-' + Date.now().toString(36); }
    function track(status, beacon) {
      if (!cfg.sheetUrl || cfg.designMode || !state.email) return;
      var a = adventure(), o = currentOffer();
      var extra = '';
      if (o && o.kind === 'bundle') {
        extra = state.extra.map(function (m, k) {
          var f = cfg.adventures[m.adventure];
          return f ? 'Film ' + (k + 2) + ' : ' + f.title + ' (' + (m.child === 'other' ? (m.name || 'autre enfant') : state.name) + ')' : '';
        }).filter(Boolean).join(' · ');
      }
      var d = {
        id: leadId, seq: Date.now(), status: status || 'En cours', step: STEP_LABELS[state.maxStep - 1] || '',
        email: state.email, childName: state.name, gender: state.gender === 'girl' ? cfg.girl : (state.gender ? cfg.boy : ''),
        age: cfg.ageShow ? state.age : '', relationship: state.relationship, adventure: a ? a.title : '',
        loves: state.loves.join(', '), lovesOther: state.lovesOther, color: state.color, occasion: state.occasion, details: state.details,
        offer: state.maxStep >= 8 && o ? o.name : '', express: status === 'Paiement commencé' ? (state.express ? 'Oui' : 'Non') : '',
        extraMovies: extra, previewUrl: state.previewUrl, utmSource: utm.source || '', utmCampaign: utm.campaign || '',
        page: location.origin + location.pathname
      };
      var body = JSON.stringify(d);
      try {
        if (beacon && navigator.sendBeacon && navigator.sendBeacon(cfg.sheetUrl, new Blob([body], { type: 'text/plain;charset=utf-8' }))) return;
        fetch(cfg.sheetUrl, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: body }).catch(function () {});
      } catch (e) {}
    }

    function save() {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({
          name: state.name, gender: state.gender, age: state.age, relationship: state.relationship, email: state.email, adventure: state.adventure,
          loves: state.loves, lovesOther: state.lovesOther, color: state.color, occasion: state.occasion, message: state.message, offer: state.offer, maxStep: state.maxStep
        }));
      } catch (e) {}
    }
    function restore() {
      try {
        var d = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
        if (!d) return;
        ['name', 'gender', 'relationship', 'email', 'lovesOther', 'color', 'occasion', 'message'].forEach(function (k) { if (typeof d[k] === 'string') state[k] = d[k]; });
        if (typeof d.age === 'number') state.age = d.age;
        if (Array.isArray(d.loves)) state.loves = d.loves;
        if (typeof d.adventure === 'number' && cfg.adventures[d.adventure]) state.adventure = d.adventure;
        if (typeof d.offer === 'number' && cfg.offers[d.offer]) state.offer = d.offer;
        if (typeof d.maxStep === 'number') state.maxStep = d.maxStep;
      } catch (e) {}
    }

    function toast(msg) {
      var el = q('[data-blf-toast]');
      if (!el || !msg) return;
      el.textContent = msg;
      el.classList.add('is-on');
      clearTimeout(el.__timer);
      el.__timer = setTimeout(function () { el.classList.remove('is-on'); }, 3800);
    }
    function setError(key, msg) {
      var el = q('[data-blf-error="' + key + '"]');
      if (!el) return;
      el.textContent = msg ? tokens(msg) : '';
      el.classList.toggle('is-on', !!msg);
    }
    function shake(el) { el.classList.remove('is-shake'); void el.offsetWidth; el.classList.add('is-shake'); }

    function fill() {
      qa('[data-blf-name]').forEach(function (el) { el.textContent = displayName(); });
      var a = adventure();
      qa('[data-blf-adventure]').forEach(function (el) { el.textContent = a ? a.title : ''; });
      var img = state.previewUrl || (a && a.preview) || (a && a.image) || '';
      qa('[data-blf-preview-img]').forEach(function (el) { if (img) el.src = img; else el.removeAttribute('src'); });
      renderSummary();
    }

    function renderSummary() {
      var offer = cfg.offers[state.offer];
      var total = offer ? price(offer.price) : 0;
      qa('[data-blf-total]').forEach(function (el) { el.textContent = money(total); });
      qa('.blf-o').forEach(function (p, i) { p.classList.toggle('is-selected', i === state.offer); });
      var nudge = q('[data-blf-nudge]');
      if (nudge) nudge.hidden = !(offer && offer.kind !== 'bundle' && bundleIndex() > -1);
      qa('[data-blf-free-count]').forEach(function (el) { el.textContent = freeCount(); });
      // affiches du pack : l'histoire choisie + 2 autres (ou celles déjà choisies)
      var a = adventure();
      var imgs = [a ? a.image : ''];
      qa('[data-blf-thumb]').forEach(function (el) {
        var src = imgs[+el.getAttribute('data-blf-thumb')] || '';
        if (src) { el.src = src; el.parentNode.classList.remove('is-empty'); } else { el.removeAttribute('src'); el.parentNode.classList.add('is-empty'); }
      });
      var ctaLabel = q('[data-blf-cta-label]');
      if (ctaLabel && offer) ctaLabel.textContent = tokens(offer.kind === 'bundle' && cfg.packCta ? cfg.packCta : cfg.ctaLabel);
    }

    // ---------- navigation ----------
    function updateChrome(n) {
      var visible = VISIBLE_STEP[n - 1];
      var fillEl = q('[data-blf-fill]');
      if (fillEl) fillEl.style.width = (visible / TOTAL * 100) + '%';
      var bar = q('[data-blf-progress]');
      if (bar) bar.setAttribute('aria-valuenow', visible);
      var count = q('[data-blf-count]');
      if (count) count.textContent = cfg.countLabel.replace('[n]', visible).replace('[total]', TOTAL);
      var back = q('[data-blf-back]');
      if (back) back.hidden = (n === 1 || n === 6);
      root.classList.toggle('is-offer', n === 8 || n === 9);
      var ctaLabel = q('[data-blf-cta-label]');

      var sticky = q('[data-blf-sticky]');
      if (sticky) {
        sticky.setAttribute('aria-hidden', (n === 8 || n === 9) ? 'false' : 'true');
        var b = sticky.querySelector('[data-blf-checkout]');
        if (b) b.tabIndex = (n === 8 || n === 9) ? 0 : -1;
      }
    }

    function go(n, opts) {
      opts = opts || {};
      if (n !== 6) {
        loadingToken++;
        var lv = q('.blf-load__media video');
        if (lv && !lv.paused) lv.pause();
      }
      state.step = n;
      if (n > state.maxStep) state.maxStep = n;
      screens.forEach(function (s) {
        var on = +s.getAttribute('data-blf-step') === n;
        s.hidden = !on;
        s.classList.remove('is-in');
        if (on) { void s.offsetWidth; s.classList.add('is-in'); }
      });
      updateChrome(n);
      fill();
      if (opts.push !== false) { try { history.pushState({ blfStep: n }, '', '#step-' + n); } catch (e) {} }
      if (opts.scroll !== false) {
        var frame = q('.blf-frame');
        var top = frame.getBoundingClientRect().top + window.pageYOffset - 16;
        if (Math.abs(window.pageYOffset - top) > 40 && window.pageYOffset > top - 200) window.scrollTo({ top: top, behavior: 'smooth' });
      }
      if (n === 6) startLoading();
      save();
      track();
      emit('bloop:step', publicState());
    }

    function previousScreen(n) {
      if (n === 7) return 5;
      return Math.max(1, n - 1);
    }

    q('[data-blf-back]').addEventListener('click', function () {
      if (state.step !== 7 && history.state && history.state.blfStep > 1) history.back();
      else go(previousScreen(state.step));
    });
    window.addEventListener('popstate', function (e) {
      if (!root.isConnected) return;
      var n = (e.state && e.state.blfStep) || 1;
      if (n === 6) n = state.step > 6 ? 5 : 6;
      if (n >= 6 && !state.photo) n = 5;
      if (n >= 2 && !state.email) n = 1;
      if (n === 9 && !(currentOffer() && currentOffer().kind === 'bundle')) n = 8;
      go(n, { push: false });
    });
    qa('[data-blf-go]').forEach(function (btn) { btn.addEventListener('click', function () { go(+btn.getAttribute('data-blf-go')); }); });

    // ---------- 1 · l'enfant ----------
    var f1 = q('[data-blf-form="1"]');
    var nameInput = f1.querySelector('input[name="child_name"]');
    var emailInput = f1.querySelector('input[name="email"]');
    var relSelect = f1.querySelector('select[name="relationship"]');
    var ageInput = q('[data-blf-age-input]');
    var ageVal = q('[data-blf-age-val]');
    var stages = qa('[data-blf-stage-from]');

    nameInput.addEventListener('input', function () {
      nameInput.classList.remove('is-invalid'); setError('child_name', '');
      state.name = capitalize(nameInput.value.trim());
      qa('[data-blf-name]').forEach(function (el) { el.textContent = displayName(); });
    });
    emailInput.addEventListener('input', function () { emailInput.classList.remove('is-invalid'); setError('email', ''); });
    if (relSelect) relSelect.addEventListener('change', function () { relSelect.classList.remove('is-invalid'); setError('relationship', ''); state.relationship = relSelect.value; save(); });
    f1.querySelectorAll('input[name="gender"]').forEach(function (r) { r.addEventListener('change', function () { setError('gender', ''); }); });

    function setAge(v, bump) {
      if (!ageInput) return;
      var min = +ageInput.min, max = +ageInput.max;
      v = Math.max(min, Math.min(max, Math.round(v)));
      state.age = v;
      ageInput.value = v;
      ageInput.style.setProperty('--val', ((v - min) / (max - min) * 100) + '%');
      ageVal.textContent = v + ' ' + (v === 1 ? cfg.ageUnitOne : cfg.ageUnit);
      if (bump) { ageVal.classList.remove('is-bump'); void ageVal.offsetWidth; ageVal.classList.add('is-bump'); setTimeout(function () { ageVal.classList.remove('is-bump'); }, 200); }
      var froms = [].map.call(stages, function (b) { return +b.getAttribute('data-blf-stage-from'); });
      var active = -1;
      froms.forEach(function (f, i) { if (v >= f) active = i; });
      stages.forEach(function (b, i) { b.classList.toggle('is-active', i === active); b.setAttribute('aria-pressed', i === active ? 'true' : 'false'); });
    }
    if (ageInput) {
      ageInput.addEventListener('input', function () { setAge(+ageInput.value, true); });
      stages.forEach(function (b, i) {
        b.addEventListener('click', function () {
          var from = +b.getAttribute('data-blf-stage-from');
          var next = stages[i + 1] ? +stages[i + 1].getAttribute('data-blf-stage-from') - 1 : +ageInput.max;
          setAge(Math.round((from + next) / 2), true);
        });
      });
    }

    f1.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = null;
      var name = nameInput.value.trim();
      if (!name) { nameInput.classList.add('is-invalid'); setError('child_name', t.errName); bad = bad || nameInput; }
      var g = f1.querySelector('input[name="gender"]:checked');
      if (!g) { setError('gender', t.errGender); bad = bad || f1.querySelector('input[name="gender"]'); }
      var rel = relSelect ? relSelect.value : '';
      if (relSelect && !rel) { relSelect.classList.add('is-invalid'); setError('relationship', t.errRelationship); bad = bad || relSelect; }
      var email = emailInput.value.trim();
      if (!email) { emailInput.classList.add('is-invalid'); setError('email', t.errEmailEmpty); bad = bad || emailInput; }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { emailInput.classList.add('is-invalid'); setError('email', t.errEmail); bad = bad || emailInput; }
      if (bad) { shake(f1); bad.focus(); return; }
      state.name = capitalize(name); state.gender = g.value; state.relationship = rel; state.email = email;
      emit('bloop:lead', publicState());
      if (typeof window.BloopFunnel.onLead === 'function') { try { window.BloopFunnel.onLead(publicState()); } catch (err) {} }
      go(2);
    });

    // ---------- 2 · l'aventure ----------
    var f2 = q('[data-blf-form="2"]');
    var advs = f2.querySelector('.blf-advs');
    f2.querySelectorAll('input[name="adventure"]').forEach(function (r) {
      r.addEventListener('change', function () { state.adventure = +r.value; advs.classList.add('has-choice'); setError('adventure', ''); fill(); save(); });
    });
    f2.addEventListener('submit', function (e) {
      e.preventDefault();
      if (state.adventure === null) { setError('adventure', t.errAdventure); shake(f2); return; }
      go(3);
    });

    // ---------- 3 · ce qu'il aime ----------
    var f3 = q('[data-blf-form="3"]');
    var otherInput = f3.querySelector('input[name="loves_other"]');
    f3.querySelectorAll('input[name="loves"]').forEach(function (c) { c.addEventListener('change', function () { setError('loves', ''); }); });
    f3.addEventListener('submit', function (e) {
      e.preventDefault();
      state.loves = [].map.call(f3.querySelectorAll('input[name="loves"]:checked'), function (c) { return c.value; });
      state.lovesOther = otherInput ? otherInput.value.trim() : '';
      var col = f3.querySelector('input[name="color"]:checked');
      state.color = col ? col.value : '';
      if (cfg.lovesRequired && !state.loves.length && !state.lovesOther) { setError('loves', t.errLoves); shake(f3); return; }
      go(4);
    });

    // ---------- 4 · occasion ----------
    var f4 = q('[data-blf-form="4"]');
    var msg = q('[data-blf-msg]');
    var msgCount = q('[data-blf-msg-count]');
    function updateCount() { if (msg && msgCount) msgCount.textContent = msg.value.length; }
    if (msg) msg.addEventListener('input', updateCount);
    f4.querySelectorAll('input[name="occasion"]').forEach(function (r) { r.addEventListener('change', function () { setError('occasion', ''); }); });
    qa('[data-blf-suggest]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!msg) return;
        msg.value = tokens(b.getAttribute('data-blf-suggest')).slice(0, +msg.maxLength || 90);
        updateCount();
        msg.focus();
      });
    });
    f4.addEventListener('submit', function (e) {
      e.preventDefault();
      var occ = f4.querySelector('input[name="occasion"]:checked');
      if (cfg.occRequired && !occ) { setError('occasion', t.errOccasion); shake(f4); return; }
      state.occasion = occ ? occ.value : '';
      state.message = msg ? msg.value.trim() : '';
      go(5);
    });

    // ---------- 5 · photo ----------
    var f5 = q('[data-blf-form="5"]');
    var drop = q('[data-blf-drop]');
    var fileInput = q('[data-blf-file]');
    var consent = f5.querySelector('input[name="consent"]');
    var details = f5.querySelector('textarea[name="details"]');
    function shrinkPhoto(file) {
      return new Promise(function (resolve) {
        var settled = false;
        function end(v) { if (!settled) { settled = true; resolve(v || null); } }
        setTimeout(function () { end(null); }, 8000);
        var url;
        try { url = URL.createObjectURL(file); } catch (e) { return end(null); }
        var im = new Image();
        im.onload = function () {
          var w = im.naturalWidth, h = im.naturalHeight;
          var k = w && h ? Math.min(1, 2048 / Math.max(w, h)) : 1;
          if (!w || !h || file.size < 3 * 1024 * 1024 || k === 1) { URL.revokeObjectURL(url); return end(null); }
          var c = document.createElement('canvas');
          c.width = Math.round(w * k); c.height = Math.round(h * k);
          var ctx = c.getContext('2d');
          ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
          ctx.drawImage(im, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          c.toBlob(function (b) {
            if (!b || b.size >= file.size) return end(null);
            var name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
            try { end(new File([b], name, { type: 'image/jpeg' })); } catch (e) { b.name = name; end(b); }
          }, 'image/jpeg', 0.92);
        };
        im.onerror = function () { URL.revokeObjectURL(url); end(null); };
        im.src = url;
      });
    }
    // ---------- HEIC (photos iPhone) ----------
    // Sur iPhone, on laisse le téléphone convertir le HEIC en JPEG (il le fait seul si le site n'annonce pas le HEIC).
    // Ailleurs, la page convertit le HEIC en JPEG avant l'envoi.
    var IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (IS_IOS) qa('[data-blf-file], [data-blf-mv-file]').forEach(function (inp) { inp.setAttribute('accept', 'image/jpeg,image/png,image/webp'); });
    function isHeic(f) { return /^image\/hei[cf]/i.test(f.type) || /\.hei[cf]$/i.test(f.name); }
    function jpegName(f) { return f.name.replace(/\.[^.]+$/, '') + '.jpg'; }
    function asJpegFile(blob, name) { try { return new File([blob], name, { type: 'image/jpeg' }); } catch (e) { blob.name = name; return blob; } }
    var heicLib = null;
    function loadHeicLib() {
      if (window.heic2any) return Promise.resolve(window.heic2any);
      if (heicLib) return heicLib;
      heicLib = new Promise(function (res, rej) {
        var sc = document.createElement('script');
        sc.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
        sc.onload = function () { window.heic2any ? res(window.heic2any) : rej(new Error('heic')); };
        sc.onerror = function () { heicLib = null; rej(new Error('heic')); };
        document.head.appendChild(sc);
      });
      return heicLib;
    }
    function nativeToJpeg(f) {
      // Safari sait lire le HEIC tout seul
      return new Promise(function (res, rej) {
        var url = URL.createObjectURL(f), im = new Image();
        im.onload = function () {
          var w = im.naturalWidth, h = im.naturalHeight;
          if (!w || !h) { URL.revokeObjectURL(url); return rej(new Error('heic')); }
          var k = Math.min(1, 4096 / Math.max(w, h));
          var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
          c.getContext('2d').drawImage(im, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
          c.toBlob(function (b) { b ? res(asJpegFile(b, jpegName(f))) : rej(new Error('heic')); }, 'image/jpeg', 0.92);
        };
        im.onerror = function () { URL.revokeObjectURL(url); rej(new Error('heic')); };
        im.src = url;
      });
    }
    function toUsablePhoto(f) {
      if (!isHeic(f)) return Promise.resolve(f);
      return nativeToJpeg(f).catch(function () {
        return loadHeicLib()
          .then(function (lib) { return lib({ blob: f, toType: 'image/jpeg', quality: 0.92 }); })
          .then(function (out) { return asJpegFile(Array.isArray(out) ? out[0] : out, jpegName(f)); });
      });
    }

    var photoBusy = false;
    var dropTitle = q('.blf-drop__title');
    var dropTitleText = dropTitle ? dropTitle.textContent : '';
    function acceptFile(file) {
      if (!file || photoBusy) return;
      var okType = /^image\/(jpe?g|png|webp|heic|heif)$/i.test(file.type) || /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name);
      if (!okType) { drop.classList.add('is-invalid'); setError('photo', t.errPhotoType); return; }
      if (file.size > cfg.maxMB * 1024 * 1024) { drop.classList.add('is-invalid'); setError('photo', t.errPhotoSize.replace('[size]', cfg.maxMB)); return; }
      if (!isHeic(file)) { usePhoto(file); return; }
      photoBusy = true;
      drop.classList.add('is-busy'); drop.classList.remove('is-invalid'); setError('photo', '');
      if (dropTitle) dropTitle.textContent = t.converting;
      toUsablePhoto(file).then(function (jpg) {
        photoBusy = false; drop.classList.remove('is-busy'); if (dropTitle) dropTitle.textContent = dropTitleText;
        usePhoto(jpg);
      }, function () {
        photoBusy = false; drop.classList.remove('is-busy'); if (dropTitle) dropTitle.textContent = dropTitleText;
        drop.classList.add('is-invalid'); setError('photo', t.errPhotoHeic);
      });
    }
    function usePhoto(file) {
      state.photo = file;
      state.photoOriginal = file;
      // version allégée de la photo (seulement au-dessus de 3 Mo : 2048 px, JPEG 92 %) pour un envoi rapide, même sur une connexion lente
      state.photoReady = shrinkPhoto(file).then(function (small) { if (small && state.photoOriginal === file) state.photo = small; });
      drop.classList.remove('is-invalid'); setError('photo', '');
      var img = q('[data-blf-photo-img]');
      q('[data-blf-photo-name]').textContent = file.name;
      if (img.__url) URL.revokeObjectURL(img.__url);
      if (/^image\/(jpe?g|png|webp|gif|avif)$/i.test(file.type)) { img.__url = URL.createObjectURL(file); img.src = img.__url; img.hidden = false; state.photoUrl = img.__url; }
      else { img.removeAttribute('src'); img.hidden = true; state.photoUrl = ''; }
      q('[data-blf-drop-empty]').hidden = true;
      q('[data-blf-drop-filled]').hidden = false;
      emit('bloop:photo', publicState());
    }
    fileInput.addEventListener('change', function () { acceptFile(fileInput.files && fileInput.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { acceptFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    consent.addEventListener('change', function () { consent.closest('.blf-consent').classList.remove('is-invalid'); setError('consent', ''); });
    f5.addEventListener('submit', function (e) {
      e.preventDefault();
      if (photoBusy) return;
      var bad = false;
      if (!state.photo) { drop.classList.add('is-invalid'); setError('photo', t.errPhoto); bad = true; }
      if (!consent.checked) { consent.closest('.blf-consent').classList.add('is-invalid'); setError('consent', t.errConsent); bad = true; }
      if (bad) { shake(f5); return; }
      state.details = details ? details.value.trim() : '';
      go(6);
    });

    // ---------- 6 · chargement ----------
    // La vidéo se lance avec le son. L'aperçu n'apparaît qu'à la fin de la vidéo ;
    // si l'aperçu n'est pas encore prêt à la fin, la vidéo se relance.
    var soundOn = true;
    var soundBtn = q('[data-blf-sound]');
    function loadVideo() { return q('.blf-load__media video'); }
    function playVideo(v) {
      v.muted = !soundOn;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {
        if (v.muted) return;
        // le navigateur bloque le son : on lance sans le son et on propose de l'activer
        soundOn = false;
        v.muted = true;
        if (soundBtn) soundBtn.hidden = false;
        var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {});
      });
    }
    if (soundBtn) soundBtn.addEventListener('click', function () {
      var v = loadVideo(); if (!v) return;
      soundOn = true; v.muted = false; soundBtn.hidden = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });

    function startLoading() {
      var token = ++loadingToken;
      var lines = cleanLines(cfg.lines).map(tokens);
      if (!lines.length) lines = ['…'];
      var list = q('[data-blf-load-list]'), now = q('[data-blf-load-now]'), count = q('[data-blf-load-count]'), fillEl = q('[data-blf-load-fill]');
      list.innerHTML = '';
      var duration = Math.max(3, cfg.duration) * 1000;
      var start = performance.now(), shown = -1, result = null, done = false;
      state.previewUrl = '';
      // Génération de l'aperçu : on n'accepte qu'une vraie image, entièrement téléchargée.
      // En cas d'échec (connexion lente, pas d'image renvoyée…), on réessaie tant que l'écran est affiché.
      // On n'affiche jamais la photo d'origine à la place de l'aperçu.
      var hook = window.BloopFunnel.generatePreview;
      var hasHook = typeof hook === 'function';
      var attempt = 0;
      function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
      function preload(url) {
        return new Promise(function (res, rej) {
          var im = new Image();
          im.onload = function () { res(url); };
          im.onerror = function () { rej(new Error('image')); };
          im.src = url;
        });
      }
      function loadImage(url, tries) {
        return preload(url).catch(function () {
          if (tries <= 1) throw new Error('image');
          return wait(2000).then(function () { return loadImage(url, tries - 1); });
        });
      }
      function runHook() {
        if (token !== loadingToken) return;
        attempt++;
        Promise.resolve(state.photoReady)
          .then(function () { return hook(publicState()); })
          .then(function (r) {
            var url = r && (r.imageUrl || r.image_url);
            if (!url) throw new Error('no image');
            return loadImage(url, 3);
          })
          .then(function (url) { if (token === loadingToken) result = { imageUrl: url }; })
          .catch(function () {
            if (token !== loadingToken) return;
            setTimeout(runHook, Math.min(10000, 2000 * attempt));
          });
      }
      if (hasHook) runHook();
      function isReady() { return !hasHook || result !== null; }

      // Règle de la vidéo :
      // - 1re lecture : on la regarde toujours jusqu'au bout, puis l'aperçu apparaît s'il est prêt.
      // - Sinon la vidéo se relance, et dès que l'aperçu est prêt on coupe la vidéo (sans attendre la fin).
      var video = loadVideo();
      var videoDone = !video;
      var pass = 1, passStart = 0, waitStart = 0, drawnPass = 1, msgShown = -1;
      var waitLines = cleanLines(cfg.waitLines).map(tokens);
      var lateLines = cleanLines(cfg.lateLines).map(tokens);
      if (!waitLines.length) waitLines = lines.slice(-1);
      if (!lateLines.length) lateLines = waitLines;
      if (video) {
        video.loop = false;
        try { video.currentTime = 0; } catch (e) {}
        video.onended = function () {
          if (token !== loadingToken) return;
          if (isReady() && cfg.editorStep !== 6) { videoDone = true; return; }
          // aperçu pas encore prêt : on relance la vidéo
          pass++;
          passStart = performance.now();
          if (!waitStart) waitStart = passStart;
          try { video.currentTime = 0; } catch (e) {}
          playVideo(video);
        };
        playVideo(video);
      }

      function finish() {
        if (done || token !== loadingToken) return;
        done = true;
        if (result && (result.imageUrl || result.image_url)) state.previewUrl = result.imageUrl || result.image_url;
        if (video && pass >= 2) { try { video.pause(); } catch (e) {} }
        setTimeout(function () { if (token === loadingToken) go(7); }, 450);
      }
      function addDone(text) {
        var li = document.createElement('li');
        li.innerHTML = CHECK_SVG + '<span></span>';
        li.lastChild.textContent = text;
        list.insertBefore(li, list.firstChild);
        while (list.children.length > 3) list.removeChild(list.lastChild);
      }
      function frame(ts) {
        if (token !== loadingToken) return;
        var ready = isReady();

        // 2e lecture et suivantes : messages d'attente, et on coupe dès que l'aperçu est prêt
        if (video && pass >= 2) {
          if (drawnPass === 1) {
            for (var r = Math.max(0, shown); r < lines.length; r++) addDone(lines[r]);
            shown = lines.length;
            count.textContent = '';
          }
          var msgs = pass === 2 ? waitLines : lateLines;
          if (drawnPass !== pass) msgShown = -1;
          drawnPass = pass;
          var mi = Math.floor((ts - passStart) / 4000) % msgs.length;
          if (mi !== msgShown) { msgShown = mi; now.textContent = msgs[mi]; }
          var wp = .94 + .05 * (1 - Math.exp(-(ts - waitStart) / 20000));
          fillEl.style.width = (wp * 100).toFixed(1) + '%';
          if (ready && cfg.editorStep !== 6) { fillEl.style.width = '100%'; finish(); return; }
          requestAnimationFrame(frame);
          return;
        }

        var target = duration;
        if (video && video.duration && isFinite(video.duration)) target = video.duration * 1000;
        var p = Math.min(1, (ts - start) / target);
        var complete;
        if (video) {
          complete = ready && videoDone;
          p = complete ? 1 : Math.min(p, .94);
        } else {
          if (!ready) p = Math.min(p, .94);
          complete = ready && p >= 1;
        }
        var idx = Math.min(lines.length - 1, Math.floor(p * lines.length));
        if (idx !== shown) {
          for (var i = Math.max(0, shown); i < idx; i++) addDone(lines[i]);
          shown = idx;
          now.textContent = lines[idx];
        }
        count.textContent = (idx + 1) + '/' + lines.length;
        fillEl.style.width = Math.round(p * 100) + '%';
        if (complete && cfg.editorStep === 6 && !video) { start = ts; shown = -1; list.innerHTML = ''; requestAnimationFrame(frame); return; }
        if (complete) { fillEl.style.width = '100%'; finish(); return; }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    // ---------- 8 · offres ----------
    var offerRadios = qa('input[name="offer"]');
    offerRadios.forEach(function (r) { r.addEventListener('change', function () { state.offer = +r.value; renderSummary(); save(); }); });
    var addon = q('input[name="addon"]');
    if (addon) addon.addEventListener('change', function () { state.addon = addon.checked; renderSummary(); });

    var nudgeBtn = q('[data-blf-nudge]');
    if (nudgeBtn) nudgeBtn.addEventListener('click', function () {
      var bi = bundleIndex(); if (bi < 0) return;
      state.offer = bi;
      offerRadios.forEach(function (r) { r.checked = +r.value === bi; });
      renderSummary(); save();
    });

    // ---------- pop-up : choix des films du pack ----------
    var mvSections = qa('[data-blf-mv]');
    function ensureExtra() {
      var need = freeCount();
      while (state.extra.length < need) state.extra.push({ child: 'same', name: '', photo: null, photoUrl: '', adventure: null });
      state.extra.length = need;
    }
    function takenBySame(k) {
      var used = [state.adventure];
      state.extra.forEach(function (m, j) { if (j !== k && m.child === 'same' && m.adventure !== null) used.push(m.adventure); });
      return used;
    }
    function movieTitle(adv, name) { return String(adv.movie || adv.title).replace(/\[name\]/g, name || displayName()); }
    function renderPick() {
      ensureExtra();
      var a = adventure();
      var kidImg = state.photoUrl || (a && a.image) || '';
      var fi = q('[data-blf-first-img]'); if (fi && kidImg) fi.src = kidImg;
      var ft = q('[data-blf-first-title]'); if (ft) ft.textContent = a ? movieTitle(a, displayName()) : '';
      qa('[data-blf-kid-img]').forEach(function (el) { if (kidImg) el.src = kidImg; });
      mvSections.forEach(function (sec) {
        var k = +sec.getAttribute('data-blf-mv'); var m = state.extra[k]; if (!m) return;
        sec.querySelectorAll('[data-blf-mv-child]').forEach(function (r) { r.checked = r.value === m.child; });
        var box = sec.querySelector('[data-blf-mv-new]'); box.hidden = m.child !== 'other';
        var nameIn = sec.querySelector('[data-blf-mv-name]'); if (document.activeElement !== nameIn) nameIn.value = m.name;
        var img = sec.querySelector('[data-blf-mv-img]');
        img.hidden = !m.photoUrl; if (m.photoUrl) img.src = m.photoUrl;
        sec.querySelector('[data-blf-mv-photo-empty]').hidden = !!m.photoUrl;
        sec.querySelector('[data-blf-mv-photo-change]').hidden = !m.photoUrl;
        sec.querySelector('[data-blf-mv-drop]').classList.toggle('is-filled', !!m.photoUrl);
        var taken = m.child === 'same' ? takenBySame(k) : [];
        sec.querySelectorAll('[data-blf-mvadv]').forEach(function (card) {
          var v = +card.getAttribute('data-blf-mvadv');
          var off = taken.indexOf(v) > -1;
          if (off && m.adventure === v) m.adventure = null;
          card.classList.toggle('is-off', off);
          var r = card.querySelector('input'); r.disabled = off; r.checked = m.adventure === v;
        });
      });
    }
    function mvError(sec, msg) {
      var el = sec.querySelector('[data-blf-mv-error]');
      el.textContent = msg ? tokens(msg) : ''; el.classList.toggle('is-on', !!msg);
    }
    mvSections.forEach(function (sec) {
      var k = +sec.getAttribute('data-blf-mv');
      sec.querySelectorAll('[data-blf-mv-child]').forEach(function (r) {
        r.addEventListener('change', function () { state.extra[k].child = r.value; mvError(sec, ''); renderPick(); if (r.value === 'other') { var ni = sec.querySelector('[data-blf-mv-name]'); setTimeout(function () { ni.focus(); }, 30); } });
      });
      sec.querySelectorAll('[data-blf-mv-adv]').forEach(function (r) {
        r.addEventListener('change', function () { state.extra[k].adventure = +r.value; mvError(sec, ''); renderPick(); });
      });
      var nameIn = sec.querySelector('[data-blf-mv-name]');
      nameIn.addEventListener('input', function () { state.extra[k].name = capitalize(nameIn.value.trim()); nameIn.classList.remove('is-invalid'); });
      var file = sec.querySelector('[data-blf-mv-file]');
      file.addEventListener('change', function () {
        var f = file.files && file.files[0]; if (!f) return;
        var okType = /^image\/(jpe?g|png|webp|heic|heif)$/i.test(f.type) || /\.(jpe?g|png|webp|heic|heif)$/i.test(f.name);
        if (!okType) { mvError(sec, t.errPhotoType); return; }
        if (f.size > cfg.maxMB * 1024 * 1024) { mvError(sec, t.errPhotoSize.replace('[size]', cfg.maxMB)); return; }
        var dropEl = sec.querySelector('[data-blf-mv-drop]');
        dropEl.classList.add('is-busy'); mvError(sec, '');
        toUsablePhoto(f).then(function (jpg) {
          dropEl.classList.remove('is-busy');
          var m = state.extra[k];
          if (m.photoUrl) URL.revokeObjectURL(m.photoUrl);
          m.photo = jpg; m.photoUrl = /^image\/(jpe?g|png|webp|gif|avif)$/i.test(jpg.type) ? URL.createObjectURL(jpg) : '';
          dropEl.classList.remove('is-invalid');
          mvError(sec, ''); renderPick();
        }, function () { dropEl.classList.remove('is-busy'); mvError(sec, t.errPhotoHeic); });
      });
    });
    function validatePick() {
      var first = null;
      mvSections.forEach(function (sec) {
        var k = +sec.getAttribute('data-blf-mv'); var m = state.extra[k]; var msg = '';
        if (m.child === 'other') {
          if (!m.name) { msg = cfg.pick.errName; sec.querySelector('[data-blf-mv-name]').classList.add('is-invalid'); }
          else if (!m.photo) { msg = cfg.pick.errPhoto; sec.querySelector('[data-blf-mv-drop]').classList.add('is-invalid'); }
        }
        if (!msg && m.adventure === null) msg = cfg.pick.errAdventure.replace('[n]', k + 2);
        mvError(sec, msg);
        if (msg && !first) first = sec;
      });
      if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'start' }); shake(first); return false; }
      return true;
    }
    function openPick() { renderPick(); openModal(pickModal); if (state.maxStep < 9) { state.maxStep = 9; save(); track(); } }

    // ---------- commande ----------
    var checkoutBtn = q('[data-blf-checkout]');
    var modal = q('[data-blf-express]');
    var pickModal = q('[data-blf-pick]');
    var lastFocus = null;
    function openModal(m) {
      if (!m) return;
      lastFocus = document.activeElement;
      m.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var card = m.querySelector('.blf-modal__card'); if (card) setTimeout(function () { card.scrollTop = 0; card.focus({ preventScroll: true }); }, 50);
    }
    function closeModal(m) {
      if (!m || m.hidden) return;
      m.hidden = true;
      if ((!modal || modal.hidden) && (!pickModal || pickModal.hidden)) document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function findVariant(list, keyword, wantPack) {
      keyword = String(keyword || '').toLowerCase().trim();
      var pool = (list || []).filter(function (v) {
        var isPack = keyword && String(v.title).toLowerCase().indexOf(keyword) > -1;
        return wantPack ? isPack : !isPack;
      });
      var ok = pool.filter(function (v) { return v.available; });
      return (ok[0] || pool[0] || {}).id || null;
    }
    function buildItems() {
      var offer = currentOffer();
      var a = adventure();
      if (!offer || !a) return null;
      var props = { 'Child name': state.name, 'Child': state.gender === 'girl' ? cfg.girl : cfg.boy, 'Movie': tokens(a.movie || a.title), 'Adventure': a.title, 'Parent email': state.email };
      if (cfg.ageShow) props['Age'] = String(state.age);
      if (state.relationship) props['Relationship'] = state.relationship;
      var loves = state.loves.slice(); if (state.lovesOther) loves.push(state.lovesOther);
      if (loves.length) props['Loves'] = loves.join(', ');
      if (state.color) props['Favorite color'] = state.color;
      if (state.occasion) props['Occasion'] = state.occasion;
      if (state.message) props['Message'] = state.message;
      if (state.details) props['Details'] = state.details;
      if (state.photo) props['Photo file'] = state.photo.name;
      if (state.previewUrl) props['_Preview'] = state.previewUrl;
      var id = null;
      if (offer.kind === 'bundle') {
        state.extra.forEach(function (m, k) {
          var f = cfg.adventures[m.adventure]; if (!f) return;
          var who = m.child === 'other' ? m.name : state.name;
          props['Movie ' + (k + 2) + ' (free)'] = movieTitle(f, who) + ' · ' + f.title;
          props['Movie ' + (k + 2) + ' child'] = who + (m.child === 'other' ? ' (another child)' : '');
          if (m.child === 'other' && m.photo) props['Movie ' + (k + 2) + ' photo file'] = m.photo.name;
        });
        id = findVariant(a.variants, offer.keyword, true) || offer.variant;
      } else {
        id = offer.variant || findVariant(a.variants, (cfg.offers[bundleIndex()] || {}).keyword, false);
      }
      if (!id) return null;
      var items = [{ id: id, quantity: 1, properties: props }];
      if (state.addon && cfg.addon && cfg.addon.variant) items.push({ id: cfg.addon.variant, quantity: 1, properties: { 'Child name': state.name } });
      if (state.express && cfg.express.variant) items.push({ id: cfg.express.variant, quantity: 1, properties: { 'Child name': state.name } });
      return items;
    }
    function busy(on) {
      checkoutBtn.classList.toggle('is-loading', on);
      qa('[data-blf-ex-yes], [data-blf-ex-no], [data-blf-pick-go]').forEach(function (b) { b.classList.toggle('is-loading', on); });
    }
    function goToCheckout() {
      var data = publicState();
      emit('bloop:checkout', data);
      track('Paiement commencé', true);
      if (typeof window.BloopFunnel.onCheckout === 'function') { try { if (window.BloopFunnel.onCheckout(data) === false) return; } catch (err) {} }
      var items = buildItems();
      if (!items || (state.express && !cfg.express.variant)) { toast(t.testMode); return; }
      busy(true);
      var root_ = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      fetch(root_ + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () {
          return fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = root_ + 'checkout'; })
        .catch(function () { busy(false); toast(t.cartError); });
    }
    function openExpress() {
      if (!modal || !cfg.express.show) { state.express = false; goToCheckout(); return; }
      var tot = modal.querySelector('[data-blf-ex-total]');
      var base = 0; var o = currentOffer(); if (o) base += price(o.price);
      if (state.addon && cfg.addon) base += price(cfg.addon.price);
      if (tot) tot.textContent = money(base + price(cfg.express.price));
      openModal(modal);
    }
    function closeExpress() { closeModal(modal); }
    if (modal) {
      modal.querySelectorAll('[data-blf-ex-close]').forEach(function (b) { b.addEventListener('click', closeExpress); });
      modal.querySelector('[data-blf-ex-yes]').addEventListener('click', function () { state.express = true; goToCheckout(); });
      modal.querySelector('[data-blf-ex-no]').addEventListener('click', function () { state.express = false; goToCheckout(); });
    }
    if (pickModal) {
      pickModal.querySelectorAll('[data-blf-pick-close]').forEach(function (b) { b.addEventListener('click', function () { closeModal(pickModal); }); });
      pickModal.querySelector('[data-blf-pick-go]').addEventListener('click', function () {
        if (!validatePick()) return;
        state.express = false;
        goToCheckout();
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeModal(modal); closeModal(pickModal); } });

    var packGo = q('[data-blf-pack-go]');
    if (packGo) packGo.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var bi = bundleIndex(); if (bi < 0) return;
      state.offer = bi; offerRadios.forEach(function (r) { r.checked = +r.value === bi; });
      renderSummary(); save(); openPick();
    });

    checkoutBtn.addEventListener('click', function () {
      var offer = currentOffer();
      if (offer && offer.kind === 'bundle' && offer.freeCount > 0) { openPick(); return; }
      openExpress();
    });

    // ---------- démarrage : restaurer les réponses ----------
    restore();
    nameInput.value = state.name;
    emailInput.value = state.email;
    if (relSelect && state.relationship) relSelect.value = state.relationship;
    f1.querySelectorAll('input[name="gender"]').forEach(function (r) { r.checked = r.value === state.gender; });
    setAge(state.age, false);
    f2.querySelectorAll('input[name="adventure"]').forEach(function (r) { r.checked = +r.value === state.adventure; });
    if (state.adventure !== null) advs.classList.add('has-choice');
    f3.querySelectorAll('input[name="loves"]').forEach(function (c) { c.checked = state.loves.indexOf(c.value) > -1; });
    if (otherInput) otherInput.value = state.lovesOther;
    f3.querySelectorAll('input[name="color"]').forEach(function (r) { r.checked = r.value === state.color; });
    f4.querySelectorAll('input[name="occasion"]').forEach(function (r) { r.checked = r.value === state.occasion; });
    if (msg) { msg.value = state.message; updateCount(); }
    offerRadios.forEach(function (r) { r.checked = +r.value === state.offer; });

    var startScreen = cfg.editorStep || 1;
    if (cfg.editorStep >= 3 && state.adventure === null && cfg.adventures.length) state.adventure = 0;
    if (cfg.editorStep === 9 && bundleIndex() > -1) { state.offer = bundleIndex(); offerRadios.forEach(function (r) { r.checked = +r.value === state.offer; }); startScreen = 8; setTimeout(openPick, 300); }
    try { history.replaceState({ blfStep: startScreen }, '', location.pathname + location.search); } catch (e) {}
    go(startScreen, { push: false, scroll: false });
  }

  function boot() { document.querySelectorAll('[data-bl-funnel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloop-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(wrap) {
      if (wrap.__blVideo) return;
      var video = wrap.querySelector('video');
      var button = wrap.querySelector('[data-bl-unmute]');
      if (!video || !button) return;
      wrap.__blVideo = true;
      video.controls = false;
      video.muted = true;
      wrap.classList.add('is-muted');
      function hideButton() { button.hidden = true; wrap.classList.remove('is-muted'); }
      function unmute() {
        video.muted = false;
        video.volume = 1;
        video.currentTime = 0;
        video.controls = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
        hideButton();
      }
      button.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); unmute(); });
      video.addEventListener('click', function () { if (video.muted && !button.hidden) unmute(); });
      video.addEventListener('volumechange', function () { if (!video.muted) hideButton(); });
    }
    function boot() { document.querySelectorAll('[data-bl-video]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloop-questionnaire"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  // écran interne -> étape affichée (le chargement et l'aperçu comptent pour une seule étape)
  var VISIBLE_STEP = [1, 2, 3, 4, 5, 6, 6, 7, 7];
  var TOTAL = 7;
  var STORE_KEY = 'bloop-funnel-v2';

  window.BloopFunnel = window.BloopFunnel || {};

  function init(root) {
    if (root.__blfReady) return;
    root.__blfReady = true;

    var cfg = JSON.parse(root.querySelector('[data-blf-config]').textContent);
    var t = cfg.t;
    var screens = root.querySelectorAll('[data-blf-step]');
    var state = {
      step: 1, name: '', gender: '', age: cfg.ageDefault, email: '', adventure: null,
      loves: [], lovesOther: '', color: '', occasion: '', message: '',
      photo: null, photoUrl: '', photoRemote: '', details: '', offer: Math.max(0, Math.min(cfg.defaultOffer, cfg.offers.length - 1)), addon: false, previewUrl: '', extra: [], express: false
    };
    var loadingToken = 0;

    // les pop-ups et le message sont déplacés à la fin de <body> pour couvrir toute la page
    var portal = null;
    (function makePortal() {
      var old = document.querySelector('[data-blf-portal="' + cfg.uid + '"]');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      var moving = root.querySelectorAll('[data-blf-express], [data-blf-pick], [data-blf-toast]');
      if (!moving.length) return;
      portal = document.createElement('div');
      portal.className = 'bl blf-portal' + (root.classList.contains('bl--theme-fonts') ? ' bl--theme-fonts' : '');
      portal.setAttribute('data-blf-portal', cfg.uid);
      portal.setAttribute('style', root.getAttribute('style') || '');
      [].forEach.call(moving, function (el) { portal.appendChild(el); });
      document.body.appendChild(portal);
    })();
    function q(sel) { return root.querySelector(sel) || (portal ? portal.querySelector(sel) : null); }
    function qa(sel) { var list = [].slice.call(root.querySelectorAll(sel)); if (portal) list = list.concat([].slice.call(portal.querySelectorAll(sel))); return list; }
    function displayName() { return state.name || cfg.fallback; }
    function adventure() { return state.adventure === null ? null : cfg.adventures[state.adventure]; }
    function tokens(str) { var a = adventure(); return String(str || '').replace(/\[name\]/g, displayName()).replace(/\[adventure\]/g, a ? a.title : ''); }
    function price(v) { var n = parseFloat(String(v || '0').replace(',', '.').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
    function money(n) { return cfg.currency + n.toFixed(2); }
    function cleanLines(list) { return (list || []).map(function (l) { return String(l).replace(/<br\s*\/?>/g, '').trim(); }).filter(Boolean); }
    function capitalize(v) { return v.replace(/(^|[\s-])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); }); }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function emit(name, detail) { root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); }
    function bundleIndex() { for (var i = 0; i < cfg.offers.length; i++) { if (cfg.offers[i].kind === 'bundle') return i; } return -1; }
    function currentOffer() { return cfg.offers[state.offer] || null; }
    function freeCount() { var o = currentOffer(); var bo = o && o.kind === 'bundle' ? o : cfg.offers[bundleIndex()]; return bo ? bo.freeCount : 0; }
    function publicState() {
      return {
        step: state.step, childName: state.name, gender: state.gender, age: cfg.ageShow ? state.age : null, email: state.email,
        adventure: adventure(), adventureIndex: state.adventure, loves: state.loves.slice(), lovesOther: state.lovesOther, color: state.color,
        occasion: state.occasion, message: state.message, photo: state.photo, details: state.details,
        offer: cfg.offers[state.offer] || null, addon: state.addon, previewUrl: state.previewUrl,
        extraMovies: state.extra.map(function (m) { return { child: m.child === 'other' ? 'another child' : 'same child', name: m.child === 'other' ? m.name : state.name, photo: m.child === 'other' ? m.photo : state.photo, adventure: cfg.adventures[m.adventure] || null }; }), express: state.express
      };
    }
    window.BloopFunnel.getState = publicState;

    function save() {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({
          name: state.name, gender: state.gender, age: state.age, email: state.email, adventure: state.adventure,
          loves: state.loves, lovesOther: state.lovesOther, color: state.color, occasion: state.occasion, message: state.message, offer: state.offer
        }));
      } catch (e) {}
    }
    function restore() {
      try {
        var d = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
        if (!d) return;
        ['name', 'gender', 'email', 'lovesOther', 'color', 'occasion', 'message'].forEach(function (k) { if (typeof d[k] === 'string') state[k] = d[k]; });
        if (typeof d.age === 'number') state.age = d.age;
        if (Array.isArray(d.loves)) state.loves = d.loves;
        if (typeof d.adventure === 'number' && cfg.adventures[d.adventure]) state.adventure = d.adventure;
        if (typeof d.offer === 'number' && cfg.offers[d.offer]) state.offer = d.offer;
      } catch (e) {}
    }

    function toast(msg) {
      var el = q('[data-blf-toast]');
      if (!el || !msg) return;
      el.textContent = msg;
      el.classList.add('is-on');
      clearTimeout(el.__timer);
      el.__timer = setTimeout(function () { el.classList.remove('is-on'); }, 3800);
    }
    function setError(key, msg) {
      var el = q('[data-blf-error="' + key + '"]');
      if (!el) return;
      el.textContent = msg ? tokens(msg) : '';
      el.classList.toggle('is-on', !!msg);
    }
    function shake(el) { el.classList.remove('is-shake'); void el.offsetWidth; el.classList.add('is-shake'); }

    function fill() {
      qa('[data-blf-name]').forEach(function (el) { el.textContent = displayName(); });
      var a = adventure();
      qa('[data-blf-adventure]').forEach(function (el) { el.textContent = a ? a.title : ''; });
      var img = state.previewUrl || (a && a.preview) || state.photoUrl || (a && a.image) || '';
      qa('[data-blf-preview-img]').forEach(function (el) { if (img) el.src = img; else el.removeAttribute('src'); });
      renderSummary();
    }

    function renderSummary() {
      var offer = cfg.offers[state.offer];
      var total = offer ? price(offer.price) : 0;
      qa('[data-blf-total]').forEach(function (el) { el.textContent = money(total); });
      qa('.blf-o').forEach(function (p, i) { p.classList.toggle('is-selected', i === state.offer); });
      var nudge = q('[data-blf-nudge]');
      if (nudge) nudge.hidden = !(offer && offer.kind !== 'bundle' && bundleIndex() > -1);
      qa('[data-blf-free-count]').forEach(function (el) { el.textContent = freeCount(); });
      // affiches du pack : l'histoire choisie + 2 autres (ou celles déjà choisies)
      var a = adventure();
      var imgs = [a ? a.image : ''];
      qa('[data-blf-thumb]').forEach(function (el) {
        var src = imgs[+el.getAttribute('data-blf-thumb')] || '';
        if (src) { el.src = src; el.parentNode.classList.remove('is-empty'); } else { el.removeAttribute('src'); el.parentNode.classList.add('is-empty'); }
      });
      var ctaLabel = q('[data-blf-cta-label]');
      if (ctaLabel && offer) ctaLabel.textContent = tokens(offer.kind === 'bundle' && cfg.packCta ? cfg.packCta : cfg.ctaLabel);
    }

    // ---------- navigation ----------
    function updateChrome(n) {
      var visible = VISIBLE_STEP[n - 1];
      var fillEl = q('[data-blf-fill]');
      if (fillEl) fillEl.style.width = (visible / TOTAL * 100) + '%';
      var bar = q('[data-blf-progress]');
      if (bar) bar.setAttribute('aria-valuenow', visible);
      var count = q('[data-blf-count]');
      if (count) count.textContent = cfg.countLabel.replace('[n]', visible).replace('[total]', TOTAL);
      var back = q('[data-blf-back]');
      if (back) back.hidden = (n === 1 || n === 6);
      root.classList.toggle('is-offer', n === 8 || n === 9);
      var ctaLabel = q('[data-blf-cta-label]');

      var sticky = q('[data-blf-sticky]');
      if (sticky) {
        sticky.setAttribute('aria-hidden', (n === 8 || n === 9) ? 'false' : 'true');
        var b = sticky.querySelector('[data-blf-checkout]');
        if (b) b.tabIndex = (n === 8 || n === 9) ? 0 : -1;
      }
    }

    function go(n, opts) {
      opts = opts || {};
      if (n !== 6) loadingToken++;
      state.step = n;
      screens.forEach(function (s) {
        var on = +s.getAttribute('data-blf-step') === n;
        s.hidden = !on;
        s.classList.remove('is-in');
        if (on) { void s.offsetWidth; s.classList.add('is-in'); }
      });
      updateChrome(n);
      fill();
      if (opts.push !== false) { try { history.pushState({ blfStep: n }, '', '#step-' + n); } catch (e) {} }
      if (opts.scroll !== false) {
        var frame = q('.blf-frame');
        var top = frame.getBoundingClientRect().top + window.pageYOffset - 16;
        if (Math.abs(window.pageYOffset - top) > 40 && window.pageYOffset > top - 200) window.scrollTo({ top: top, behavior: 'smooth' });
      }
      if (n === 6) startLoading();
      save();
      emit('bloop:step', publicState());
    }

    function previousScreen(n) {
      if (n === 7) return 5;
      return Math.max(1, n - 1);
    }

    q('[data-blf-back]').addEventListener('click', function () {
      if (state.step !== 7 && history.state && history.state.blfStep > 1) history.back();
      else go(previousScreen(state.step));
    });
    window.addEventListener('popstate', function (e) {
      if (!root.isConnected) return;
      var n = (e.state && e.state.blfStep) || 1;
      if (n === 6) n = state.step > 6 ? 5 : 6;
      if (n >= 6 && !state.photo) n = 5;
      if (n >= 2 && !state.email) n = 1;
      if (n === 9 && !(currentOffer() && currentOffer().kind === 'bundle')) n = 8;
      go(n, { push: false });
    });
    qa('[data-blf-go]').forEach(function (btn) { btn.addEventListener('click', function () { go(+btn.getAttribute('data-blf-go')); }); });

    // ---------- 1 · l'enfant ----------
    var f1 = q('[data-blf-form="1"]');
    var nameInput = f1.querySelector('input[name="child_name"]');
    var emailInput = f1.querySelector('input[name="email"]');
    var ageInput = q('[data-blf-age-input]');
    var ageVal = q('[data-blf-age-val]');
    var stages = qa('[data-blf-stage-from]');

    nameInput.addEventListener('input', function () {
      nameInput.classList.remove('is-invalid'); setError('child_name', '');
      state.name = capitalize(nameInput.value.trim());
      qa('[data-blf-name]').forEach(function (el) { el.textContent = displayName(); });
    });
    emailInput.addEventListener('input', function () { emailInput.classList.remove('is-invalid'); setError('email', ''); });
    f1.querySelectorAll('input[name="gender"]').forEach(function (r) { r.addEventListener('change', function () { setError('gender', ''); }); });

    function setAge(v, bump) {
      if (!ageInput) return;
      var min = +ageInput.min, max = +ageInput.max;
      v = Math.max(min, Math.min(max, Math.round(v)));
      state.age = v;
      ageInput.value = v;
      ageInput.style.setProperty('--val', ((v - min) / (max - min) * 100) + '%');
      ageVal.textContent = v + ' ' + (v === 1 ? cfg.ageUnitOne : cfg.ageUnit);
      if (bump) { ageVal.classList.remove('is-bump'); void ageVal.offsetWidth; ageVal.classList.add('is-bump'); setTimeout(function () { ageVal.classList.remove('is-bump'); }, 200); }
      var froms = [].map.call(stages, function (b) { return +b.getAttribute('data-blf-stage-from'); });
      var active = -1;
      froms.forEach(function (f, i) { if (v >= f) active = i; });
      stages.forEach(function (b, i) { b.classList.toggle('is-active', i === active); b.setAttribute('aria-pressed', i === active ? 'true' : 'false'); });
    }
    if (ageInput) {
      ageInput.addEventListener('input', function () { setAge(+ageInput.value, true); });
      stages.forEach(function (b, i) {
        b.addEventListener('click', function () {
          var from = +b.getAttribute('data-blf-stage-from');
          var next = stages[i + 1] ? +stages[i + 1].getAttribute('data-blf-stage-from') - 1 : +ageInput.max;
          setAge(Math.round((from + next) / 2), true);
        });
      });
    }

    f1.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = null;
      var name = nameInput.value.trim();
      if (!name) { nameInput.classList.add('is-invalid'); setError('child_name', t.errName); bad = bad || nameInput; }
      var g = f1.querySelector('input[name="gender"]:checked');
      if (!g) { setError('gender', t.errGender); bad = bad || f1.querySelector('input[name="gender"]'); }
      var email = emailInput.value.trim();
      if (!email) { emailInput.classList.add('is-invalid'); setError('email', t.errEmailEmpty); bad = bad || emailInput; }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { emailInput.classList.add('is-invalid'); setError('email', t.errEmail); bad = bad || emailInput; }
      if (bad) { shake(f1); bad.focus(); return; }
      state.name = capitalize(name); state.gender = g.value; state.email = email;
      emit('bloop:lead', publicState());
      if (typeof window.BloopFunnel.onLead === 'function') { try { window.BloopFunnel.onLead(publicState()); } catch (err) {} }
      go(2);
    });

    // ---------- 2 · l'aventure ----------
    var f2 = q('[data-blf-form="2"]');
    var advs = f2.querySelector('.blf-advs');
    f2.querySelectorAll('input[name="adventure"]').forEach(function (r) {
      r.addEventListener('change', function () { state.adventure = +r.value; advs.classList.add('has-choice'); setError('adventure', ''); fill(); save(); });
    });
    f2.addEventListener('submit', function (e) {
      e.preventDefault();
      if (state.adventure === null) { setError('adventure', t.errAdventure); shake(f2); return; }
      go(3);
    });

    // ---------- 3 · ce qu'il aime ----------
    var f3 = q('[data-blf-form="3"]');
    var otherInput = f3.querySelector('input[name="loves_other"]');
    f3.querySelectorAll('input[name="loves"]').forEach(function (c) { c.addEventListener('change', function () { setError('loves', ''); }); });
    f3.addEventListener('submit', function (e) {
      e.preventDefault();
      state.loves = [].map.call(f3.querySelectorAll('input[name="loves"]:checked'), function (c) { return c.value; });
      state.lovesOther = otherInput ? otherInput.value.trim() : '';
      var col = f3.querySelector('input[name="color"]:checked');
      state.color = col ? col.value : '';
      if (cfg.lovesRequired && !state.loves.length && !state.lovesOther) { setError('loves', t.errLoves); shake(f3); return; }
      go(4);
    });

    // ---------- 4 · occasion & message ----------
    var f4 = q('[data-blf-form="4"]');
    var msg = q('[data-blf-msg]');
    var msgCount = q('[data-blf-msg-count]');
    function updateCount() { if (msg && msgCount) msgCount.textContent = msg.value.length; }
    if (msg) msg.addEventListener('input', updateCount);
    f4.querySelectorAll('input[name="occasion"]').forEach(function (r) { r.addEventListener('change', function () { setError('occasion', ''); }); });
    qa('[data-blf-suggest]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!msg) return;
        msg.value = tokens(b.getAttribute('data-blf-suggest')).slice(0, +msg.maxLength || 90);
        updateCount();
        msg.focus();
      });
    });
    f4.addEventListener('submit', function (e) {
      e.preventDefault();
      var occ = f4.querySelector('input[name="occasion"]:checked');
      if (cfg.occRequired && !occ) { setError('occasion', t.errOccasion); shake(f4); return; }
      state.occasion = occ ? occ.value : '';
      state.message = msg ? msg.value.trim() : '';
      go(5);
    });

    // ---------- 5 · photo ----------
    var f5 = q('[data-blf-form="5"]');
    var drop = q('[data-blf-drop]');
    var fileInput = q('[data-blf-file]');
    var consent = f5.querySelector('input[name="consent"]');
    var details = f5.querySelector('textarea[name="details"]');
    function acceptFile(file) {
      if (!file) return;
      var okType = /^image\//.test(file.type) || /\.(heic|heif)$/i.test(file.name);
      if (!okType) { drop.classList.add('is-invalid'); setError('photo', t.errPhotoType); return; }
      if (file.size > cfg.maxMB * 1024 * 1024) { drop.classList.add('is-invalid'); setError('photo', t.errPhotoSize.replace('[size]', cfg.maxMB)); return; }
      state.photo = file;
      state.photoRemote = ''; state.previewUrl = '';
      drop.classList.remove('is-invalid'); setError('photo', '');
      var img = q('[data-blf-photo-img]');
      q('[data-blf-photo-name]').textContent = file.name;
      if (img.__url) URL.revokeObjectURL(img.__url);
      if (/^image\/(jpe?g|png|webp|gif|avif)$/i.test(file.type)) { img.__url = URL.createObjectURL(file); img.src = img.__url; img.hidden = false; state.photoUrl = img.__url; }
      else { img.removeAttribute('src'); img.hidden = true; state.photoUrl = ''; }
      q('[data-blf-drop-empty]').hidden = true;
      q('[data-blf-drop-filled]').hidden = false;
      emit('bloop:photo', publicState());
    }
    fileInput.addEventListener('change', function () { acceptFile(fileInput.files && fileInput.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { acceptFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    consent.addEventListener('change', function () { consent.closest('.blf-consent').classList.remove('is-invalid'); setError('consent', ''); });
    f5.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = false;
      if (!state.photo) { drop.classList.add('is-invalid'); setError('photo', t.errPhoto); bad = true; }
      if (!consent.checked) { consent.closest('.blf-consent').classList.add('is-invalid'); setError('consent', t.errConsent); bad = true; }
      if (bad) { shake(f5); return; }
      state.details = details ? details.value.trim() : '';
      go(6);
    });

    // ---------- 6 · chargement ----------
    function startLoading() {
      var token = ++loadingToken;
      var lines = cleanLines(cfg.lines).map(tokens);
      if (!lines.length) lines = ['…'];
      var list = q('[data-blf-load-list]'), now = q('[data-blf-load-now]'), count = q('[data-blf-load-count]'), fillEl = q('[data-blf-load-fill]');
      list.innerHTML = '';
      var duration = Math.max(3, cfg.duration) * 1000;
      var start = performance.now(), shown = -1, result = null, done = false;
      var hook = window.BloopFunnel.generatePreview;
      var pending = typeof hook === 'function'
        ? Promise.resolve().then(function () { return hook(publicState()); }).then(function (r) { result = r || {}; }, function () { result = {}; })
        : null;
      if (pending) setTimeout(function () { if (token === loadingToken && result === null) result = {}; }, 80000);
      function finish() {
        if (done || token !== loadingToken) return;
        done = true;
        if (result && (result.imageUrl || result.image_url)) state.previewUrl = result.imageUrl || result.image_url;
        if (result && (result.photoUrl || result.photo_url)) state.photoRemote = result.photoUrl || result.photo_url;
        setTimeout(function () { if (token === loadingToken) go(7); }, 450);
      }
      function frame(ts) {
        if (token !== loadingToken) return;
        var p = Math.min(1, (ts - start) / duration);
        var waiting = pending && result === null;
        if (waiting) p = Math.min(p, .94);
        var idx = Math.min(lines.length - 1, Math.floor(p * lines.length));
        if (idx !== shown) {
          for (var i = Math.max(0, shown); i < idx; i++) {
            var li = document.createElement('li');
            li.innerHTML = CHECK_SVG + '<span></span>';
            li.lastChild.textContent = lines[i];
            list.insertBefore(li, list.firstChild);
            while (list.children.length > 3) list.removeChild(list.lastChild);
          }
          shown = idx;
          now.textContent = lines[idx];
        }
        count.textContent = (idx + 1) + '/' + lines.length;
        fillEl.style.width = Math.round(p * 100) + '%';
        if (p >= 1 && !waiting && cfg.editorStep === 6) { start = ts; shown = -1; list.innerHTML = ''; requestAnimationFrame(frame); return; }
        if (p >= 1 && !waiting) { fillEl.style.width = '100%'; finish(); return; }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    // ---------- 8 · offres ----------
    var offerRadios = qa('input[name="offer"]');
    offerRadios.forEach(function (r) { r.addEventListener('change', function () { state.offer = +r.value; renderSummary(); save(); }); });
    var addon = q('input[name="addon"]');
    if (addon) addon.addEventListener('change', function () { state.addon = addon.checked; renderSummary(); });

    var nudgeBtn = q('[data-blf-nudge]');
    if (nudgeBtn) nudgeBtn.addEventListener('click', function () {
      var bi = bundleIndex(); if (bi < 0) return;
      state.offer = bi;
      offerRadios.forEach(function (r) { r.checked = +r.value === bi; });
      renderSummary(); save();
    });

    // ---------- pop-up : choix des films du pack ----------
    var mvSections = qa('[data-blf-mv]');
    function ensureExtra() {
      var need = freeCount();
      while (state.extra.length < need) state.extra.push({ child: 'same', name: '', photo: null, photoUrl: '', adventure: null });
      state.extra.length = need;
    }
    function takenBySame(k) {
      var used = [state.adventure];
      state.extra.forEach(function (m, j) { if (j !== k && m.child === 'same' && m.adventure !== null) used.push(m.adventure); });
      return used;
    }
    function movieTitle(adv, name) { return String(adv.movie || adv.title).replace(/\[name\]/g, name || displayName()); }
    function renderPick() {
      ensureExtra();
      var a = adventure();
      var kidImg = state.photoUrl || (a && a.image) || '';
      var fi = q('[data-blf-first-img]'); if (fi && kidImg) fi.src = kidImg;
      var ft = q('[data-blf-first-title]'); if (ft) ft.textContent = a ? movieTitle(a, displayName()) : '';
      qa('[data-blf-kid-img]').forEach(function (el) { if (kidImg) el.src = kidImg; });
      mvSections.forEach(function (sec) {
        var k = +sec.getAttribute('data-blf-mv'); var m = state.extra[k]; if (!m) return;
        sec.querySelectorAll('[data-blf-mv-child]').forEach(function (r) { r.checked = r.value === m.child; });
        var box = sec.querySelector('[data-blf-mv-new]'); box.hidden = m.child !== 'other';
        var nameIn = sec.querySelector('[data-blf-mv-name]'); if (document.activeElement !== nameIn) nameIn.value = m.name;
        var img = sec.querySelector('[data-blf-mv-img]');
        img.hidden = !m.photoUrl; if (m.photoUrl) img.src = m.photoUrl;
        sec.querySelector('[data-blf-mv-photo-empty]').hidden = !!m.photoUrl;
        sec.querySelector('[data-blf-mv-photo-change]').hidden = !m.photoUrl;
        sec.querySelector('[data-blf-mv-drop]').classList.toggle('is-filled', !!m.photoUrl);
        var taken = m.child === 'same' ? takenBySame(k) : [];
        sec.querySelectorAll('[data-blf-mvadv]').forEach(function (card) {
          var v = +card.getAttribute('data-blf-mvadv');
          var off = taken.indexOf(v) > -1;
          if (off && m.adventure === v) m.adventure = null;
          card.classList.toggle('is-off', off);
          var r = card.querySelector('input'); r.disabled = off; r.checked = m.adventure === v;
        });
      });
    }
    function mvError(sec, msg) {
      var el = sec.querySelector('[data-blf-mv-error]');
      el.textContent = msg ? tokens(msg) : ''; el.classList.toggle('is-on', !!msg);
    }
    mvSections.forEach(function (sec) {
      var k = +sec.getAttribute('data-blf-mv');
      sec.querySelectorAll('[data-blf-mv-child]').forEach(function (r) {
        r.addEventListener('change', function () { state.extra[k].child = r.value; mvError(sec, ''); renderPick(); if (r.value === 'other') { var ni = sec.querySelector('[data-blf-mv-name]'); setTimeout(function () { ni.focus(); }, 30); } });
      });
      sec.querySelectorAll('[data-blf-mv-adv]').forEach(function (r) {
        r.addEventListener('change', function () { state.extra[k].adventure = +r.value; mvError(sec, ''); renderPick(); });
      });
      var nameIn = sec.querySelector('[data-blf-mv-name]');
      nameIn.addEventListener('input', function () { state.extra[k].name = capitalize(nameIn.value.trim()); nameIn.classList.remove('is-invalid'); });
      var file = sec.querySelector('[data-blf-mv-file]');
      file.addEventListener('change', function () {
        var f = file.files && file.files[0]; if (!f) return;
        var okType = /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name);
        if (!okType) { mvError(sec, t.errPhotoType); return; }
        if (f.size > cfg.maxMB * 1024 * 1024) { mvError(sec, t.errPhotoSize.replace('[size]', cfg.maxMB)); return; }
        var m = state.extra[k];
        if (m.photoUrl) URL.revokeObjectURL(m.photoUrl);
        m.photo = f; m.photoUrl = /^image\/(jpe?g|png|webp|gif|avif)$/i.test(f.type) ? URL.createObjectURL(f) : '';
        m.photoRemote = '';
        var up = window.BloopFunnel.uploadPhoto;
        if (typeof up === 'function') {
          var job = Promise.resolve().then(function () { return up(f); })
            .then(function (u) { if (m.photo === f) m.photoRemote = u || ''; }, function () {})
            .then(function () { if (m.uploading === job) m.uploading = null; });
          m.uploading = job;
        }
        sec.querySelector('[data-blf-mv-drop]').classList.remove('is-invalid');
        mvError(sec, ''); renderPick();
      });
    });
    function validatePick() {
      var first = null;
      mvSections.forEach(function (sec) {
        var k = +sec.getAttribute('data-blf-mv'); var m = state.extra[k]; var msg = '';
        if (m.child === 'other') {
          if (!m.name) { msg = cfg.pick.errName; sec.querySelector('[data-blf-mv-name]').classList.add('is-invalid'); }
          else if (!m.photo) { msg = cfg.pick.errPhoto; sec.querySelector('[data-blf-mv-drop]').classList.add('is-invalid'); }
        }
        if (!msg && m.adventure === null) msg = cfg.pick.errAdventure.replace('[n]', k + 2);
        mvError(sec, msg);
        if (msg && !first) first = sec;
      });
      if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'start' }); shake(first); return false; }
      return true;
    }
    function openPick() { renderPick(); openModal(pickModal); }

    // ---------- commande ----------
    var checkoutBtn = q('[data-blf-checkout]');
    var modal = q('[data-blf-express]');
    var pickModal = q('[data-blf-pick]');
    var lastFocus = null;
    function openModal(m) {
      if (!m) return;
      lastFocus = document.activeElement;
      m.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var card = m.querySelector('.blf-modal__card'); if (card) setTimeout(function () { card.scrollTop = 0; card.focus({ preventScroll: true }); }, 50);
    }
    function closeModal(m) {
      if (!m || m.hidden) return;
      m.hidden = true;
      if ((!modal || modal.hidden) && (!pickModal || pickModal.hidden)) document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function findVariant(list, keyword, wantPack) {
      keyword = String(keyword || '').toLowerCase().trim();
      var pool = (list || []).filter(function (v) {
        var isPack = keyword && String(v.title).toLowerCase().indexOf(keyword) > -1;
        return wantPack ? isPack : !isPack;
      });
      var ok = pool.filter(function (v) { return v.available; });
      return (ok[0] || pool[0] || {}).id || null;
    }
    function buildItems() {
      var offer = currentOffer();
      var a = adventure();
      if (!offer || !a) return null;
      var props = { 'Child name': state.name, 'Child': state.gender === 'girl' ? cfg.girl : cfg.boy, 'Movie': tokens(a.movie || a.title), 'Adventure': a.title, 'Parent email': state.email };
      if (cfg.ageShow) props['Age'] = String(state.age);
      var loves = state.loves.slice(); if (state.lovesOther) loves.push(state.lovesOther);
      if (loves.length) props['Loves'] = loves.join(', ');
      if (state.color) props['Favorite color'] = state.color;
      if (state.occasion) props['Occasion'] = state.occasion;
      if (state.message) props['Message'] = state.message;
      if (state.details) props['Details'] = state.details;
      if (state.photo) props['Photo file'] = state.photo.name;
      if (state.previewUrl) props['_Preview'] = state.previewUrl;
      if (state.photoRemote) props['_Photo URL'] = state.photoRemote;
      var id = null;
      if (offer.kind === 'bundle') {
        state.extra.forEach(function (m, k) {
          var f = cfg.adventures[m.adventure]; if (!f) return;
          var who = m.child === 'other' ? m.name : state.name;
          props['Movie ' + (k + 2) + ' (free)'] = movieTitle(f, who) + ' · ' + f.title;
          props['Movie ' + (k + 2) + ' child'] = who + (m.child === 'other' ? ' (another child)' : '');
          if (m.child === 'other' && m.photo) props['Movie ' + (k + 2) + ' photo file'] = m.photo.name;
          if (m.child === 'other' && m.photoRemote) props['Movie ' + (k + 2) + ' photo URL'] = m.photoRemote;
        });
        id = findVariant(a.variants, offer.keyword, true) || offer.variant;
      } else {
        id = offer.variant || findVariant(a.variants, (cfg.offers[bundleIndex()] || {}).keyword, false);
      }
      if (!id) return null;
      var items = [{ id: id, quantity: 1, properties: props }];
      if (state.addon && cfg.addon && cfg.addon.variant) items.push({ id: cfg.addon.variant, quantity: 1, properties: { 'Child name': state.name } });
      if (state.express && cfg.express.variant) items.push({ id: cfg.express.variant, quantity: 1, properties: { 'Child name': state.name } });
      return items;
    }
    function busy(on) {
      checkoutBtn.classList.toggle('is-loading', on);
      qa('[data-blf-ex-yes], [data-blf-ex-no], [data-blf-pick-go]').forEach(function (b) { b.classList.toggle('is-loading', on); });
    }
    function ensurePhotos() {
      var up = window.BloopFunnel.uploadPhoto;
      var jobs = [];
      if (state.photo && !state.photoRemote && typeof up === 'function') {
        var f = state.photo;
        jobs.push(Promise.resolve().then(function () { return up(f); }).then(function (u) { if (u && state.photo === f) state.photoRemote = u; }, function () {}));
      }
      state.extra.forEach(function (m) { if (m.uploading) jobs.push(m.uploading); });
      return Promise.all(jobs);
    }
    function goToCheckout() {
      var data = publicState();
      emit('bloop:checkout', data);
      if (typeof window.BloopFunnel.onCheckout === 'function') { try { if (window.BloopFunnel.onCheckout(data) === false) return; } catch (err) {} }
      if (!buildItems() || (state.express && !cfg.express.variant)) { toast(t.testMode); return; }
      busy(true);
      var root_ = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      ensurePhotos()
        .then(function () { return fetch(root_ + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }); })
        .then(function () {
          return fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: buildItems() }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = root_ + 'checkout'; })
        .catch(function () { busy(false); toast(t.cartError); });
    }
    function openExpress() {
      if (!modal || !cfg.express.show) { state.express = false; goToCheckout(); return; }
      var tot = modal.querySelector('[data-blf-ex-total]');
      var base = 0; var o = currentOffer(); if (o) base += price(o.price);
      if (state.addon && cfg.addon) base += price(cfg.addon.price);
      if (tot) tot.textContent = money(base + price(cfg.express.price));
      openModal(modal);
    }
    function closeExpress() { closeModal(modal); }
    if (modal) {
      modal.querySelectorAll('[data-blf-ex-close]').forEach(function (b) { b.addEventListener('click', closeExpress); });
      modal.querySelector('[data-blf-ex-yes]').addEventListener('click', function () { state.express = true; goToCheckout(); });
      modal.querySelector('[data-blf-ex-no]').addEventListener('click', function () { state.express = false; goToCheckout(); });
    }
    if (pickModal) {
      pickModal.querySelectorAll('[data-blf-pick-close]').forEach(function (b) { b.addEventListener('click', function () { closeModal(pickModal); }); });
      pickModal.querySelector('[data-blf-pick-go]').addEventListener('click', function () {
        if (!validatePick()) return;
        state.express = false;
        goToCheckout();
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeModal(modal); closeModal(pickModal); } });

    var packGo = q('[data-blf-pack-go]');
    if (packGo) packGo.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var bi = bundleIndex(); if (bi < 0) return;
      state.offer = bi; offerRadios.forEach(function (r) { r.checked = +r.value === bi; });
      renderSummary(); save(); openPick();
    });

    checkoutBtn.addEventListener('click', function () {
      var offer = currentOffer();
      if (offer && offer.kind === 'bundle' && offer.freeCount > 0) { openPick(); return; }
      openExpress();
    });

    // ---------- démarrage : restaurer les réponses ----------
    restore();
    nameInput.value = state.name;
    emailInput.value = state.email;
    f1.querySelectorAll('input[name="gender"]').forEach(function (r) { r.checked = r.value === state.gender; });
    setAge(state.age, false);
    f2.querySelectorAll('input[name="adventure"]').forEach(function (r) { r.checked = +r.value === state.adventure; });
    if (state.adventure !== null) advs.classList.add('has-choice');
    f3.querySelectorAll('input[name="loves"]').forEach(function (c) { c.checked = state.loves.indexOf(c.value) > -1; });
    if (otherInput) otherInput.value = state.lovesOther;
    f3.querySelectorAll('input[name="color"]').forEach(function (r) { r.checked = r.value === state.color; });
    f4.querySelectorAll('input[name="occasion"]').forEach(function (r) { r.checked = r.value === state.occasion; });
    if (msg) { msg.value = state.message; updateCount(); }
    offerRadios.forEach(function (r) { r.checked = +r.value === state.offer; });

    var startScreen = cfg.editorStep || 1;
    if (cfg.editorStep >= 3 && state.adventure === null && cfg.adventures.length) state.adventure = 0;
    if (cfg.editorStep === 9 && bundleIndex() > -1) { state.offer = bundleIndex(); offerRadios.forEach(function (r) { r.checked = +r.value === state.offer; }); startScreen = 8; setTimeout(openPick, 300); }
    try { history.replaceState({ blfStep: startScreen }, '', location.pathname + location.search); } catch (e) {}
    go(startScreen, { push: false, scroll: false });
  }

  function boot() { document.querySelectorAll('[data-bl-funnel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloop-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-bl-scroll]');
    if (arrow) {
      var track = document.getElementById(arrow.getAttribute('aria-controls'));
      if (!track) return;
      var direction = arrow.getAttribute('data-bl-scroll') === 'prev' ? -1 : 1;
      track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.8, 260), behavior: 'smooth' });
      return;
    }
    var play = event.target.closest('[data-bl-play]');
    if (!play) return;
    var card = play.closest('.bl-vreview');
    var video = card && card.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.bl-vreview video').forEach(function (other) {
      if (other !== video && !other.paused) other.pause();
    });
    video.muted = false;
    video.controls = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
    play.hidden = true;
    card.classList.add('is-playing');
    // à la fin de la vidéo, on remet le bouton play et la légende
    video.onended = function () {
      video.controls = false;
      try { video.currentTime = 0; } catch (e) {}
      play.hidden = false;
      card.classList.remove('is-playing');
    };
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__blNav) return;
    root.__blNav = true;
    var drawer = root.querySelector('[data-bl-drawer]');
    var opener = root.querySelector('[data-bl-nav-open]');
    var lastFocus = null;

    function open() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('button[data-bl-nav-close]');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
    }
    function close() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (opener) opener.addEventListener('click', open);
    root.querySelectorAll('[data-bl-nav-close]').forEach(function (el) { el.addEventListener('click', close); });
    if (drawer) drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });

    var dds = root.querySelectorAll('[data-bl-dd]');
    dds.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) dds.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      dds.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      close();
      dds.forEach(function (d) { if (d.open) { d.open = false; d.querySelector('summary').focus(); } });
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { root.classList.toggle('is-scrolled', window.scrollY > 4); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  function boot() { document.querySelectorAll('[data-bl-nav]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
